import { Cluster, PublicKey } from '@solana/web3.js';
import { IDL_V6 } from './idl/jupiter6';

export const JUPITER_PROGRAM_V4_ID = new PublicKey('JUP4Fb2cqiRUcaTHdrPC8h2gNsA2ETXiPDD33WcGuJB');
export const JUPITER_PROGRAM_V6_ID = new PublicKey('JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4');

export const JUPITER_PROGRAM_ID_DEVNET = new PublicKey('BHzPYvC5J38kUeqkcUXwfraLWJ68cmGWm43ksF3i8bmk');
export const JUPITER_PROGRAM_ID_STAGING = new PublicKey('JUPSjgjMFjU4453KMgxhqVmzep6W352bQpE4RsNqXAx');

export const MAINNET_SERUM_DEX_PROGRAM = new PublicKey('9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin');

export const DEVNET_SERUM_DEX_PROGRAM = new PublicKey('DESVgJVGajEgKGXhb6XmqDHGz3VjdgP7rEVESBgxmroY');

export const RAYDIUM_AMM_V4_PROGRAM_ID = new PublicKey('675kPX9MHTjS2zt1qfr1NYHuzeLXfQM9H24wFSUt1Mp8');

export const ALDRIN_SWAP_PROGRAM_ID = new PublicKey('AMM55ShdkoGRB5jVYPjWziwk8m5MpwyDgsMWHaMSQWH6');

// https://github.com/aldrin-exchange/aldrin-sdk/blob/f93fe3f2d847d79d8ddff507d8d4f62fd803421b/src/v2.json
export const ALDRIN_SWAP_V2_PROGRAM_ID = new PublicKey('CURVGoZn8zycx6FXwwevgBTB2gVvdbGTEpvMJDbgs2t4');

export const SABER_ADD_DECIMALS_PROGRAM_ID = new PublicKey('DecZY86MU5Gj7kppfUCEmd4LbXXuyZH1yHaP2NTqdiZB');

export const CROPPER_PROGRAM_ID = new PublicKey('CTMAxxk34HjKWxQ3QLZK1HpaLXmBveao3ESePXbiyfzh');

export const SENCHA_PROGRAM_ID = new PublicKey('SCHAtsf8mbjyjiv4LkhLKutTf6JnZAbdJKFkXQNMFHZ');

export const LIFINITY_PROGRAM_ID = new PublicKey('EewxydAPCCVuNEyrVN68PuSYdQ7wKn27V9Gjeoi8dy3S');

export const CREMA_PROGRAM_ID = new PublicKey('CLMM9tUoggJu2wagPkkqs9eFG4BWhVBZWkP1qv3Sp7tR');
// Crema requires a separate partner account controlled by them
export const CREMA_PARTNER_ACCOUNT = new PublicKey('FxYoB1VAx8TfLCwvmworJy16VH89v992qznUvBX5aR8K');

export const MERCURIAL_SWAP_PROGRAM_ID = new PublicKey('MERLuDFBMmsHnsBPZw2sDQZHvXFMwp8EdjudcU2HKky');

export const WHIRLPOOL_PROGRAM_ID = new PublicKey('whirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc');

export const INVARIANT_PROGRAM_ID = new PublicKey('HyaB3W9q6XdA5xwpU4XnSZV94htfmbmqJXZcEbRaJutt');
export const INVARIANT_STATE_ID = new PublicKey('8NsPwRFYqob3FzYvHYTjFK6WVFJADFN8Hn7yNQKcVNW1');
export const INVARIANT_PROGRAM_AUTHORITY_ID = new PublicKey('J4uBbeoWpZE8fH58PM1Fp9n9K6f1aThyeVCyRdJbaXqt');

export const CYKURA_PROGRAM_ID = new PublicKey('cysPXAjehMpVKUapzbMCCnpFxUFFryEWEaLgnb9NrR8');

export const CYKURA_FACTORY_STATE_ADDRESS = new PublicKey('DBsMwKfeoUHhxMi9x6wd2AsT12UwUCssjNbUzu1aKgqj');

export const MARINADE_PROGRAM_ID = new PublicKey('MarBmsSgKXdrN1egZf5sqe1TMai9K1rChYNDJgjq7aD');

export const STEPN_PROGRAM_ID = new PublicKey('Dooar9JkhdZ7J3LHN3A7YCuoGRUggXhQaG4kijfLGU2j');
export const ORCA_V1_PROGRAM_ID = new PublicKey('DjVE6JNiYqPL2QXyCUUh8rNjHrbz9hXHNYt99MQ59qw1');
export const ORCA_V2_PROGRAM_ID = new PublicKey('9W959DqEETiGZocYWCQPaJ6sBmUzgfxXfqGeTEdp3aQP');
export const STEP_TOKEN_SWAP_PROGRAM_ID = new PublicKey('SSwpMgqNDsyV7mAgN9ady4bDVu5ySjmmXejXvy2vLt1');

export const PENGUIN_PROGRAM_ID = new PublicKey('PSwapMdSai8tjrEXcxFeQth87xC4rRsa4VA5mhGhXkP');
export const SAROS_PROGRAM_ID = new PublicKey('SSwapUtytfBdBn1b9NUGG6foMVPtcWgpRU32HToDUZr');

export const METEORA_PROGRAM_ID = new PublicKey('Eo7WjKq67rjJQSZxS6z3YkapzY3eMj6Xy8X5EQVn5UaB');
export const METEORA_VAULT_PROGRAM_ID = new PublicKey('24Uqj9JCLxUeoC3hGfh5W3s9FM9uCHDS2SG3LYwBpyTi');

export const DELTA_FI_PROGRAM_ID = new PublicKey('GNExJhNUhc9LN2DauuQAUJnXoy6DJ6zey3t9kT9A2PF3');
export const DELTA_FI_USER_ID = new PublicKey('ziSPuDShwunW4xNrCfTnSHTPVT6FZDREtdofpf1BJwe');

export const GOOSE_FX_PROGRAM_ID = new PublicKey('7WduLbRfYhTJktjLw5FDEyrqoEv61aTTCuGAetgLjzN5');
export const GOOSE_FX_CONTROLLER_ID = new PublicKey('8CxKnuJeoeQXFwiG6XiGY2akBjvJA5k3bE52BfnuEmNQ');

export const BALANSOL_PROGRAM_ID = new PublicKey('D3BBjqUdCYuP18fNvvMbPAZ8DpcRi4io2EsYHQawJDag');

export const DRADEX_PROGRAM_ID = new PublicKey('dp2waEWSBy5yKmq65ergoU3G6qRLmqa6K7We4rZSKph');
export const DRADEX_LOGGER_PROGRAM_ID = new PublicKey('1gE3LGQze8DQ3KD2C4ZUCmRX5g4njhY5yLfYmnmcvJR');
export const DRADEX_MASTER_ID = new PublicKey('76ygWLcvJLR6nSzRUpiQqqtX4Pabkq4vpaTxwr3mDcXA');

export const LIFINITY_V2_PROGRAM_ID = new PublicKey('2wT8Yq49kHgDzXuPxZSaeLaH1qbmGXtEyPy64bL7aD3c');

// This is DexUser for Dradex with `BUX7s2ef2htTGb2KKoPHWkmzxPj4nTWMWRgs5CSbQxf9` as owner.
export const DRADEX_DEX_USER = new PublicKey('571oqNkJauZ2tccLwf8CUB56hpLPZkop9X1Px4DE9rnQ');

export const RAYDIUM_CLMM_PROGRAM_ID = new PublicKey('CAMMCzo5YL8w4VFF8KVHrK22GGUsp5VTaW7grrKgrWqK');
export const OPENBOOK_PROGRAM_ID = new PublicKey('srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX');

export const MARCO_POLO_PROGRAM_ID = new PublicKey('9tKE7Mbmj4mxDjWatikzGAtkoWosiiZX9y6J4Hfm2R8H');
export const MARCO_POLO_STATE_ID = new PublicKey('BE5YRQ6N6LCw7UL3JwzVp317EWa4mzJY6JKDaudcXu7A');
export const MARCO_POLO_PROGRAM_AUTHORITY = new PublicKey('JM78XNzeQRmZXDAP4DSq88ZdErbuSXSLE6fkRsVDKSu');

export const BONK_SWAP_PROGRAM_ID = new PublicKey('BSwp6bEBihVLdqJRKGgzjcGLHkcTuzmSo1TQkHepzH8p');
export const BONK_SWAP_STATE_ID = new PublicKey('2QWN6WjrJ3RAk51ecxLxaLPfFCYLAnmWJwJ1oKA92CRD');
export const BONK_SWAP_PROGRAM_AUTHORITY = new PublicKey('8NyaPDJeC2eaBGpkRpZKnD9S448AZGgjSvumFe92DRK2');

export const PHOENIX_PROGRAM_ID = new PublicKey('PhoeNiXZ8ByJGLkxNfZRnkUfjvmuYqLR89jjFHGqdXY');

export const SYMMETRY_PROGRAM_ID = new PublicKey('2KehYt3KsEQR53jYcxjbQp2d2kCp4AkuQW68atufRwSr');

export const WRAPPED_SOL_MINT = new PublicKey('So11111111111111111111111111111111111111112');

export const MARKETS_URL: Record<Cluster, string> = {
  devnet: 'https://jupiter-devnet.zhen8558.workers.dev/markets?v=3', // 'https://api.jup.ag/api/markets/cache/devnet',
  'mainnet-beta': 'https://cache.jup.ag/markets?v=3',
  testnet: 'https://api.jup.ag/api/markets/cache/devnet',
};

export const INDEXED_ROUTE_MAP_URL = 'https://cache.jup.ag/indexed-route-maps-v3';

export const TOKEN_LIST_URL: Record<Cluster & 'localnet', string> = {
  devnet: 'https://api.jup.ag/api/tokens/devnet',
  testnet: 'https://api.jup.ag/api/markets/devnet',
  'mainnet-beta': 'https://cache.jup.ag/tokens',
  localnet: 'https://cache.jup.ag/tokens',
};

export const LAMPORTS_PER_SIGNATURE = 5000;

// The default wallet collecting referrer fees
export const JUPITER_FEE_OWNER = new PublicKey('BUX7s2ef2htTGb2KKoPHWkmzxPj4nTWMWRgs5CSbQxf9');

export interface ErrorDetails {
  code: number;
  name: string;
  msg: string;
}

type COMMON_ERRORS = keyof typeof JUPITER_COMMON_ERRORS;

type JUPITER_V6_ERROR_TYPES = COMMON_ERRORS | (typeof IDL_V6.errors)[number]['name'];

export const JUPITER_COMMON_ERRORS = {
  AlreadyInUse: {
    code: 0,
    name: 'AlreadyInUsed',
    msg: 'Account already In Used',
  },
  InsufficientSOL: {
    code: 1,
    name: 'InsufficientSOL',
    msg: 'Insufficient SOL',
  },
  TransactionNotConfirmed: {
    code: 7000, // a code that is not in the list of errors
    name: 'TransactionNotConfirmed',
    msg: 'Transaction was not confirmed',
  },
  BalancesNotExtractedProperly: {
    code: 7001, // a code that is not in the list of errors
    name: 'BalancesNotExtractedProperly',
    msg: 'Balances cannot be extracted properly',
  },
  TooManyAccountLocked: {
    code: 7002,
    name: 'TooManyAccountsLocked',
    msg: 'Transaction not proccessed due to too many accounts locked',
  },
  FrozenAccount: {
    code: 17,
    name: 'FrozenAccount',
    msg: 'The token account is frozen',
  },
};

export const JUPITER_V6_ERRORS: Record<JUPITER_V6_ERROR_TYPES, ErrorDetails> = Object.freeze({
  ...JUPITER_COMMON_ERRORS,
  ...IDL_V6.errors.reduce((accErrors, error) => {
    return { ...accErrors, [error.name]: error };
  }, {} as Record<(typeof IDL_V6.errors)[number]['name'], ErrorDetails>),
});
